var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padded"},[_vm._m(0),_c('br'),_vm._v(" "),_c('op-stats',{attrs:{"show-requests":false}}),_vm._v(" "),_c('ticket-summary'),_vm._v(" "),_c('events-calendar',{attrs:{"category":"tickets"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dash-heading"},[_c('i',{staticClass:"fa fa-globe"}),_vm._v(" Maintenance Summary")])
}]

export { render, staticRenderFns }